import * as microsoftTeams from "@microsoft/teams-js";
import { TEAMS_AUTH_TOKEN } from "../../constants/storageKeys";
import { debugLog, errorLog } from "../../util/debug";

export function AuthInitialize(initializedCallback) {
  debugLog("calling initialize");
  microsoftTeams.app.initialize().then(() => {
    debugLog("teams.initialze successful, calling getContext...");

    microsoftTeams.app.getContext().then((context) => {
      debugLog("getContext success: ", context);
      debugLog("calling getAuthToken()");

      microsoftTeams.authentication.getAuthToken().then((response) => {
          debugLog("received successful AAD Token response");
          window.localStorage.setItem(TEAMS_AUTH_TOKEN, response);
      }).catch((error) => {
          errorLog("received failed  AAD Token response: ", error);
          alert("FAILED TO GET MS TEAMS TOKEN:." + error);
      });

      initializedCallback(context);
    });
  });
}
